import { EnglishStr } from "@/lib/EnglishStr";
import ErrorTemplate from "./ErrorTemplate";

export default function NotFound() {
  
  return (
    <ErrorTemplate
      title="Page Not Found"
      content={"The page you requested could not be found."}
    />
  );
}
